export enum SearchCriteriaKeys {
    CheckIn = 'data[od]',
    CheckOut = 'data[do]',
    Adults = 'miejsca_dorosli',
    Children = 'miejsca_dzieci',
    ChildrenAges = 'wiek_dzieci',
    OnlineReservation = 'rezerwacja_online',
}
